import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNowStrict  } from 'date-fns';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: false // So it updates with time
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: Date | string | number): string {
    if (!value) return '';
    try {
      return formatDistanceToNowStrict(new Date(value), { addSuffix: true });
    } catch {
      return '';
    }
  }
}
